import { useEffect, useState, useRef, useReducer } from "react";
import { Datatable } from "tw-elements";
import ErrorModal from "../../Components/Common/ErrorModal";
import * as Constants from "../../Constants/constants";
import { TETabs, TETabsContent, TETabsItem, TETabsPane, TEInput } from "tw-elements-react";
import { motion } from "framer-motion";
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { LineupRequest } from "../../Model/Lineup/LineupRequest";

/* INI: Configuração Grid */

const colorRow = (cell, value) => {

  if (value === 0)
    cell.parentElement.classList.add("!bg-[#FFE200]", "hover:bg-slate-50", "!text-slate-900");
  if (value === 1) 
    cell.parentElement.classList.add("!bg-[#009E40]", "hover:bg-lime-200", "!text-white");
  
  if (value === 2) 
    cell.parentElement.classList.add("!bg-blue-950", "hover:bg-blue-800", "!text-white");
  
  if (value === 3) 
    cell.parentElement.classList.add("!bg-neutral-200", "hover:bg-neutral-100", "!text-slate-900");
  
  cell.classList.add("hidden");

};

const gridOptions =
{
  bordered: true,
  hover: true,
  noFoundMessage: "Sem dados para este filtro.",
  striped: false,
  fixedHeader: true,
  pagination: false,
  loading: true,
  selectable: false,
  multi: false,
  maxHeight: "30rem"
};

const noData = {
  columns: [
    { label: 'Sem dados para exibição', field: 'none' },
  ],
  rows: [
  ],
};

const dataLineup = {
  columns: [
    
    { label: 'Viagem', field: 'viagem', sort: false },
    { label: 'Navio', field: 'navio', sort: false },
    { label: 'Serviço', field: 'joint', sort: false },
    //{ label: 'Armador', field: 'operator', sort: false },
    { label: 'Abertura<br>gate', field: 'aberturaGate', sort: false },
    { label: 'Deadline', field: 'deadline', sort: false },
    { label: 'Chegada<br>esperada', field: 'previsaoChegada', sort: false },
    { label: 'Atracação<br>esperada', field: 'previsaoAtracacao', sort: false },
    { label: 'Atracação', field: 'atracacao', sort: false },
    { label: 'Início<br> operação', field: 'inicioOperacao', sort: false },
    { label: 'Término<br>operação', field: 'termino', sort: false },
    { label: 'Desatracação<br> prevista', field: 'previsaoSaida', sort: false },
    { label: 'Desatracação', field: 'saida', sort: false },
    { label: '', field: 'tipoItemLineup', format: colorRow , sort: false},
    //{ label: 'Berço', field: 'berco', sort: true }
  ],
  rows: [
  ],
};


/* FIM: Configuração Grid */

export default function LineupView() {
  // States
  const [errors, setErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [verticalActive, setVerticalActive] = useState("todos");
  const [datatableInstances, setdataTableInstances] = useState({});
  const [atualizando, setAtualizando] = useState(false);
  const [excelGenerating, setExcelGenerating] = useState(false);
  // Refs
  const tableSearchRef = useRef(null);
  const verticalActiveRef = useRef(verticalActive);
  const datatableInstancesRef = useRef(datatableInstances);
  // Reducer
  const [lineupRequest, dispatch] = useReducer(lineupRequestReducer, { ...new LineupRequest() });
  function lineupRequestReducer(lineupRequest, action) {
    
    if (action.valor == undefined)
      return { ...lineupRequest };

    if (action.type == "chegada-de")
      return { ...lineupRequest, ChegadaDe: action.valor };

    if (action.type == "chegada-ate")
      return { ...lineupRequest, ChegadaAte: action.valor };
  }
  // Handlers
  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }
    setVerticalActiveRef(value);
  };

  const handleSearch = (e) => {
    try {
      datatableInstancesRef.current[verticalActiveRef.current].search(e.target.value);
    } catch (ex) {
      if (ex instanceof TypeError) {
        //Silenciar bug do search no twelements quando está setado height nas options da tabela e resolver aqui
        datatableInstancesRef.current[verticalActiveRef.current]._perfectScrollbar.perfectScrollbar.element.scrollTop = 0;
      }
    }
  };

  async function handleAtualizarClick(e) {
    const newErrors = {};
    e.preventDefault();
    setAtualizando(true);
    try {
      const response = await fetch(
        Constants.LineupConstants.ENDPOINT_OBTERLINEUPCOMPLETO,
        { ...Constants.CommonConstants.DEFAULT_POST_REQUEST_OPTIONS, body: JSON.stringify(lineupRequest) }
      )

      const result = await response.json();
      if (result.success === true) {
        atualizarLineupCompleto(result.responseObject[0]);
      }
      else {
        newErrors.result = result.userFriendlyMessage;
        console.log(result.technicalMessage);
      }
    }
    catch (error) {
      newErrors.result = "Não foi possível obter as escalas de lineup, tente novamente mais tarde.";
      console.log(error);
    }
    finally {
      setAtualizando(false);
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setShowErrorModal(true);
      }
    }
  }

  const handleGerarExcel = async (e) => {
    e.preventDefault();
    const newErrors = {};
    try {
      setExcelGenerating(true);
      const response = await fetch(
        Constants.LineupConstants.ENDPOINT_EXPORTARLINEUPCOMPLETO,
        { ...Constants.CommonConstants.DEFAULT_POST_REQUEST_OPTIONS, body: JSON.stringify(lineupRequest) }
      )

      const result = await response.json();
      if (result.success === true) {

        const binaryData = atob(result.responseObject[0].file);
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const view = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          view[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = result.responseObject[0].fileName;
        downloadLink.click();
      }
      else {
        newErrors.result = result.userFriendlyMessage;
        console.log(result.technicalMessage);
        
      }

    }
    catch (error) {
      newErrors.result = "Não foi possível gerar excel do lineup no momento, tente novamente mais tarde.";
      console.log(error);
    }
    finally {
      setExcelGenerating(false);
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setShowErrorModal(true);
      }
    }
  };


  // Funcs
  const setVerticalActiveRef = data => {
    verticalActiveRef.current = data;
    setVerticalActive(data);
  };

  const setdataTableInstancesSR = data => {
    datatableInstancesRef.current = data;
    setdataTableInstances(data);
  };

  const atualizarLineupCompleto = (reponseObject) => {

    datatableInstancesRef.current['todos'].update(
      reponseObject.todos.length === 0 ? { ...noData, row: [] } : { ...dataLineup, rows: reponseObject.todos },
      { ...gridOptions, loading: false }
    );
    
    datatableInstancesRef.current['esperados'].update(
      reponseObject.esperados.length === 0 ? { ...noData, row: [] } : { ...dataLineup, rows: reponseObject.esperados },
      { ...gridOptions, loading: false }
    );
    
    datatableInstancesRef.current['atracados'].update(
      reponseObject.atracados.length === 0 ? { ...noData, row: [] } : { ...dataLineup, rows: reponseObject.atracados },
      { ...gridOptions, loading: false }
    );
    
    datatableInstancesRef.current['desatracados'].update(
      reponseObject.desatracados.length === 0 ? { ...noData, row: [] } : { ...dataLineup, rows: reponseObject.desatracados },
      { ...gridOptions, loading: false }
    );
    
    datatableInstancesRef.current['omitidos'].update(
      reponseObject.omitidos.length === 0 ? { ...noData, row: [] } : { ...dataLineup, rows: reponseObject.omitidos },
      { ...gridOptions, loading: false }
    );
    formatTables();
  }

  const obterLineupCompletoAsync = async () => {
    const newErrors = {};
    try {
      const response = await fetch(
        Constants.LineupConstants.ENDPOINT_OBTERLINEUPCOMPLETO,
        { ...Constants.CommonConstants.DEFAULT_POST_REQUEST_OPTIONS, body: JSON.stringify(lineupRequest) }
      )

      const result = await response.json();
      if (result.success === true) {
        atualizarLineupCompleto(result.responseObject[0]);
      }
      else {
        newErrors.result = result.userFriendlyMessage;
        console.log(result.technicalMessage);
      }

    }
    catch (error) {
      newErrors.result = "Não foi possível obter as escalas de lineup, tente novamente mais tarde.";
      console.log(error);
    }
    finally {
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setShowErrorModal(true);
      }
    }

  }

  const formatTables = () => {
    Object.keys(datatableInstancesRef.current).forEach( (dataTable) =>{
      // Tamanho de fonte e espessura de linha para a tabela toda.
      let tableElement = datatableInstancesRef.current[dataTable]._element.querySelectorAll('table')[0];
      tableElement.classList.add("!text-[12px]/[5px]", "!text-center");

      // Custom para os headers.
      let headerCells = tableElement.querySelectorAll('th');
      headerCells.forEach(cell => {
        cell.classList.add("!text-[12px]/[13px]", "text-center", "text-slate-700");
        cell.querySelector("span").classList.remove("pl-[18px]");
        if (cell.innerText == '')
          cell.classList.add('hidden');
      });  
    });
  }
  // Effect
  useEffect(() => {

    // Tw elements init
    const init = async () => {
      const { Datatable, initTE } = await import("tw-elements");
      initTE({ Datatable }, { allowReinits: true });
    }
    init();
    const lDatatable = {}
    // Datatables init
    lDatatable['todos'] = new Datatable(document.getElementById('tableTodos'));
    lDatatable['todos'].update({ ...noData }, gridOptions);

    lDatatable['esperados'] = new Datatable(document.getElementById('tableEsperados'));
    lDatatable['esperados'].update({ ...noData }, gridOptions);

    lDatatable['atracados'] = new Datatable(document.getElementById('tableAtracados'));
    lDatatable['atracados'].update({ ...noData }, gridOptions);

    lDatatable['desatracados'] = new Datatable(document.getElementById('tableDesatracados'));
    lDatatable['desatracados'].update({ ...noData }, gridOptions);

    lDatatable['omitidos'] = new Datatable(document.getElementById('tableOmitidos'));
    lDatatable['omitidos'].update({ ...noData }, gridOptions);

    // Populates datatables 
    setdataTableInstancesSR(lDatatable);
    obterLineupCompletoAsync();
    

    /* INI: Event listeners */
    tableSearchRef.current.addEventListener('input', handleSearch);
    return () => {
      tableSearchRef.current.removeEventListener('input', handleSearch);
    };
    /* FIM: Event listeners */

  }, []);


  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="items-center">
        <div className="container 2xl:!min-w-[1664px] 2xl:!max-w-[1664px] mx-auto pt-4 pb-4  lg:px-6 bg-white">
          <section>
            
            <div className="flex flex-wrap items-start justify-center">
              <div className="w-full shrink-0 grow-0 basis-auto lg:w-11/12  mb-5">
                <h2 className="text-2xl font-bold">Conheça nossa programação</h2>
                <h2 className="text-orange-600 mb-1 text-2xl font-bold">Lineup Rio Brasil</h2>
                <p className="text-gray-500 sm:max-w-md">
                  Veja abaixo os detalhes das nossas escalas.
                </p>

              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center">
              <div className="w-full shrink-0 grow-0 basis-auto lg:w-11/12  mb-1">
                
                <form>
                 
                  <div className="grid grid-cols-1 sm:gap-1 sm:grid-cols-4 lg:grid-cols-12">
                    
                      <div className=" col-span-1 lg:col-span-3 xl:col-span-2" >
                        <label htmlFor="time-in" className="block text-sm font-normal leading-6 text-gray-500">Chegada prevista de:</label>
                        <div className="relative mt-1 rounded-md shadow-sm z-50">
                          <DatePicker
                            name="chegada-de"
                            id="chegada-de"
                            onChange={e => { dispatch({ type: 'chegada-de', valor: e }) }}
                            value={lineupRequest.ChegadaDe}
                            format='dd/MM/yyyy'
                            dayPlaceholder='dd'
                            monthPlaceholder='mm'
                            yearPlaceholder='aaaa'
                            wrapperClassName='rounded-3xl p-2.5 text-slate-700'
                          />
                        </div>
                      </div>

                      <div className=" col-span-1 lg:col-span-3 xl:col-span-2">
                        <label htmlFor="time-out" className="block text-sm font-normal leading-6 text-gray-500">Até:</label>
                        <div className="relative mt-1 rounded-md shadow-sm  z-50">
                          <DatePicker
                            name="chegada-ate"
                            id="chegada-ate"
                            format='dd/MM/yyyy'
                            dayPlaceholder='dd'
                            monthPlaceholder='mm'
                            yearPlaceholder='aaaa'
                            onChange={e => {
                              dispatch({ type: 'chegada-ate', valor: e })
                            }
                            }
                            value={lineupRequest.ChegadaAte} />
                        </div>
                      </div>
                    

                    
                      <div className="col-span-1  justify-self-center content-end lg:justify-self-start xl:justify-self-center">
                        <button
                          onClick={handleAtualizarClick}
                          type="button"
                          className="rounded-md min-w-20 bg-orange-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                          {atualizando ? "Aguarde..." : "Atualizar"}
                          {atualizando && <svg id="spinner" aria-hidden="true" class="inline ml-1 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                          </svg>}
                        </button>
                      </div>
                      <div className=" col-span-1  justify-self-center content-end sm:justify-self-start lg:justify-self-start lg:ml-2 xl:ml-0 ">
                        <button
                          type="button"
                          disabled={excelGenerating}
                          onClick={handleGerarExcel}
                          className="rounded-md min-w-20 bg-orange-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                          {excelGenerating ? "Aguarde..." : "Exportar"}
                          {excelGenerating && <svg id="spinner" aria-hidden="true" class="inline ml-1 w-4 h-4 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                          </svg>}
                        </button>
                      </div>
                    

                    <div className="hidden lg:flex lg:col-start-9 lg:col-span-1 content-end">
                      {/*<div className="hidden xl:block mt-2 text-xs text-neutral-500">
                        <p className="text-xs text-neutral-500">Legenda:</p>
                      </div>*/}
                      <div className=" ml-4 flex flex-col items-center justify-center flex-1">
                        <p className="text-xs text-neutral-500">Esperados</p>
                        <div className="mt-2 h-6 w-9 rounded-xl bg-[#FFE200]"></div>
                      </div>
                      <div className="ml-4 flex flex-col items-center justify-center flex-1">
                        <p className="text-xs text-neutral-500">Atracados</p>
                        <div className="mt-2 h-6 w-9 rounded-xl bg-[#009E40]"></div>
                      </div>
                      <div className="ml-4 flex flex-col items-center justify-center flex-1">
                        <p className="text-xs text-neutral-500">Desatracados</p>
                        <div className="mt-2 h-6 w-9 rounded-xl bg-blue-800"></div>
                      </div>
                      <div className="ml-4 flex flex-col items-center justify-center flex-1">
                        <p className="text-xs text-neutral-500">Omitidos</p>
                        <div className="mt-2 h-6 w-9 rounded-xl bg-neutral-200"></div>
                      </div>
                    </div>

                  </div>
                </form>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-center">
              <TETabs vertical={false} fill justify className="!mb-0 w-full lg:w-11/12 ">
                <TETabsItem
                  onClick={() => handleVerticalClick("todos")}
                  active={verticalActive === "todos"}
                >
                  Todos
                </TETabsItem>
                <TETabsItem
                  onClick={() => handleVerticalClick("esperados")}
                  active={verticalActive === "esperados"}
                >
                  Esperados
                </TETabsItem>
                <TETabsItem
                  onClick={() => handleVerticalClick("atracados")}
                  active={verticalActive === "atracados"}
                >
                  Atracados
                </TETabsItem>
                <TETabsItem
                  onClick={() => handleVerticalClick("desatracados")}
                  active={verticalActive === "desatracados"}
                >
                  Desatracados
                </TETabsItem>

                <TETabsItem
                  onClick={() => handleVerticalClick("omitidos")}
                  active={verticalActive === "omitidos"}
                >
                  Omitidos
                </TETabsItem>

              </TETabs>

              <div class="relative w-full mt-3 lg:w-11/12" data-twe-input-wrapper-init>
                <input
                  type="search"
                  class="peer block min-h-[auto] w-full rounded border-1 border-slate-300/80 bg-transparent px-3 py-[0.32rem] leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 peer-focus:text-primary data-[twe-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none [&:not([data-twe-input-placeholder-active])]:placeholder:opacity-0"
                  id="table-search-input"
                  ref={tableSearchRef}
                  size="base"
                  spellCheck={false}
                  placeholder="" />
                <label
                  htmlFor="table-search-input"
                  class="pointer-events-none absolute left-3 top-0 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:z-50 peer-focus:bg-white peer-focus:!pt-0 peer-focus:-translate-y-[0.7rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[twe-input-state-active]:-translate-y-[0.9rem] peer-data-[twe-input-state-active]:scale-[0.8] motion-reduce:transition-none"
                >Filtre por qualquer termo
                </label>
              </div>
             
              <TETabsContent className="flex flex-col overflow-x-auto items-center justify-center w-full lg:w-11/12 !my-0 ">
                <TETabsPane show={verticalActive === "todos"} className="inline-block !w-full ">
                  <div
                    id="tableTodos"
                    className="pt-1 pb-2"
                  />
                </TETabsPane>
                <TETabsPane show={verticalActive === "esperados"} className="inline-block !w-full">
                  <div
                    id="tableEsperados"
                    className="pt-1 pb-2"
                  >
                  </div>
                </TETabsPane>
                <TETabsPane show={verticalActive === "atracados"} className="inline-block !w-full">
                  <div
                    id="tableAtracados"
                    className="pt-1 pb-2"
                  >
                  </div>
                </TETabsPane>
                <TETabsPane show={verticalActive === "desatracados"} className="inline-block !w-full">
                  <div
                    id="tableDesatracados"
                    className="pt-1 pb-2"
                  >
                  </div>
                </TETabsPane>
                <TETabsPane show={verticalActive === "omitidos"} className="inline-block !w-full">
                  <div
                    id="tableOmitidos"
                    className="pt-1 pb-2"
                  >
                  </div>
                </TETabsPane>
              </TETabsContent>
            </div>
            
            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-6 sm:justify-end sm:w-full lg:w-11/12">
              <div
                className=" block md:hidden rounded-md min-w-16 bg-[#FFE200] px-3 py-2 text-xs text-center font-light text-slate-700 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Esperados
              </div>
              <div
                className="block md:hidden rounded-md min-w-16 bg-[#009E40] px-3 py-2 text-xs text-center font-light text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Atracados
              </div>
              <div
                className="block md:hidden rounded-md min-w-16 bg-blue-950 px-3 py-2 text-xs text-center font-light text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Desatracados
              </div>
              <div
                className="block md:hidden rounded-md min-w-16 bg-neutral-200 px-3 py-2 text-xs text-center font-light text-slate-700 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Omitidos
              </div>
            </div>
            
          </section>
          <ErrorModal open={showErrorModal} onOpen={() => setShowErrorModal(false)} children={errors} />
        </div>
      </div>

    </motion.div>
  );
}